var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalChannel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(-628 -130.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    transform: "translate(580 279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 88.00019836425781 -113.5 L 87.04058074951172 -113.5 C 89.21408843994141 -113.5215835571289 90.97821044921875 -115.2861099243164 90.99979400634766 -117.4601135253906 L 90.99979400634766 -116.4995956420898 C 90.99979400634766 -114.8456039428711 89.65419006347656 -113.5 88.00019836425781 -113.5 Z M 59.96001815795898 -113.5 L 59.00039672851562 -113.5 C 57.34591674804688 -113.5 55.99989700317383 -114.8456039428711 55.99989700317383 -116.4995956420898 L 55.99989700317383 -117.4611282348633 C 56.02084350585938 -115.2865676879883 57.78562545776367 -113.5215911865234 59.96001815795898 -113.5 Z M 55.99989700317383 -132.5390625 L 55.99989700317383 -133.4997100830078 C 55.99989700317383 -135.1541900634766 57.34591674804688 -136.5002136230469 59.00039672851562 -136.5002136230469 L 59.96102523803711 -136.5002136230469 C 57.78607559204102 -136.4792633056641 56.02084732055664 -134.7140350341797 55.99989700317383 -132.5390625 Z M 90.99979400634766 -132.5400848388672 C 90.97821044921875 -134.7144775390625 89.21363830566406 -136.4792633056641 87.03957366943359 -136.5002136230469 L 88.00019836425781 -136.5002136230469 C 89.65419006347656 -136.5002136230469 90.99979400634766 -135.1541900634766 90.99979400634766 -133.4997100830078 L 90.99979400634766 -132.5400848388672 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 88.00019836425781 -112.5 L 59.00039672851562 -112.5 C 56.79451751708984 -112.5 54.99989700317383 -114.2942047119141 54.99989700317383 -116.4995956420898 L 54.99989700317383 -133.4997100830078 C 54.99989700317383 -135.7055816650391 56.79451751708984 -137.5002136230469 59.00039672851562 -137.5002136230469 L 88.00019836425781 -137.5002136230469 C 90.20558929443359 -137.5002136230469 91.99979400634766 -135.7055816650391 91.99979400634766 -133.4997100830078 L 91.99979400634766 -116.4995956420898 C 91.99979400634766 -114.2942047119141 90.20558929443359 -112.5 88.00019836425781 -112.5 Z M 60.00029754638672 -135.5004119873047 C 58.34576797485352 -135.5004119873047 56.99970626831055 -134.1543426513672 56.99970626831055 -132.4998016357422 L 56.99970626831055 -117.5003967285156 C 56.99970626831055 -115.8458557128906 58.34576797485352 -114.4997940063477 60.00029754638672 -114.4997940063477 L 87.00030517578125 -114.4997940063477 C 88.65433502197266 -114.4997940063477 90 -115.8458557128906 90 -117.5003967285156 L 90 -132.4998016357422 C 90 -134.1543426513672 88.65433502197266 -135.5004119873047 87.00030517578125 -135.5004119873047 L 60.00029754638672 -135.5004119873047 Z",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(638.443 131.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 29.836,
    transform: "translate(0 4.59)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x2: 17.213,
    transform: "translate(6.885)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalChannel);
export default __webpack_public_path__ + "static/media/external-channel.bbcf3073dab7c2017c318c48925812f3.svg";
export { ForwardRef as ReactComponent };